var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Form',{attrs:{"data-detail":_vm.dataDetail}})}
var staticRenderFns = []

export { render, staticRenderFns }